export {HD} from './hd_main_imports';

export async function prepareHD() { return Promise.resolve(); }
